import React, { Component } from 'react'
import { connect } from 'react-redux';
import queryString from 'query-string';

import PusherContext from '../../../_contexts/PusherContext'

import { clearState, getConversations, loadConversations, addConversation, updateConversationById } from '../../../_actions/conversation.actions'

const validation = {
  isStatus: (queryParams) => {
    return queryParams.status && queryParams.status === 'open'
  },
  isPatient: (queryParams, conversation) => {
    return queryParams.patientId && parseInt(queryParams.patientId) === conversation.patient.id
  },
  isUser: (queryParams, conversation) => {
    if ( queryParams.userId && conversation.type === 'PATIENT_INITIATED') {
      return parseInt(queryParams.userId) === parseInt(conversation.licensedUser.id)
    }

    if ( queryParams.userId && conversation.type === 'PROVIDER_INITIATED') {
      return parseInt(queryParams.userId) === parseInt(conversation.staffUser.userId)
    }

    return false;
  }
}

const withMsgListService = (WrappedComponent) => {
  class SocketService extends Component
  {
    static contextType = PusherContext
  
    constructor(props) {
      super(props)
      
      this.conversationInterval = false;

      this.conversationCreated = this.conversationCreated.bind(this)
      this.conversationUpdated = this.conversationUpdated.bind(this)
    }
  
    componentDidMount() {
      this.getConversations()

      if (this.context.connection.state === 'unavailable') {
        this.initiatePolling()
      }

      this.initiateSocket();
    }

    componentDidUpdate(prevProps) {
      if (prevProps.location.search !== this.props.location.search) {
        this.getConversations()
      }
    }

    componentWillUnmount() {
      this.props.dispatch(clearState())

      this.unSubscribeChannels();

      this.disablePolling()
    }

    initiateSocket() {
      this.conversationsChannel = this.context.subscribe(`private-conversations_client.${this.props.clientId}`)

      this.conversationsChannel
        .bind('conversationCreated',  this.conversationCreated)
        .bind('conversationUpdated',  this.conversationUpdated)

      this.context.connection.bind('state_change', this.connectionChange, this)
    }

    connectionChange(state) {
      if (state.current === 'connected') {
          this.disablePolling()
      } else if (state.current === 'unavailable' || state.current === 'failed') {
        this.initiatePolling()
      }
    }

    conversationCreated (conversation) {
      const queryParams = queryString.parse(this.props.location.search);

      if (
        (validation.isStatus(queryParams) && validation.isPatient(queryParams, conversation) && validation.isUser(queryParams, conversation)) ||
        (!validation.isStatus(queryParams) && !validation.isPatient(queryParams, conversation) && !validation.isUser(queryParams, conversation)) ||
        (!validation.isStatus(queryParams) && validation.isPatient(queryParams, conversation) && validation.isUser(queryParams, conversation)) ||
        (validation.isStatus(queryParams) && !validation.isPatient(queryParams, conversation) && validation.isUser(queryParams, conversation)) ||
        (validation.isStatus(queryParams) && validation.isPatient(queryParams, conversation) && !validation.isUser(queryParams, conversation)) ||
        (validation.isStatus(queryParams) && !validation.isPatient(queryParams, conversation) && !validation.isUser(queryParams, conversation)) ||
        (!validation.isStatus(queryParams) && validation.isPatient(queryParams, conversation) && !validation.isUser(queryParams, conversation)) ||
        (!validation.isStatus(queryParams) && !validation.isPatient(queryParams, conversation) && validation.isUser(queryParams, conversation))
      ) {
        this.props.dispatch(addConversation(conversation))
      }
    }

    conversationUpdated (conversation) {
      this.props.dispatch(updateConversationById(conversation))
    }
  
    initiatePolling() {
      if (this.conversationInterval === false) {
        this.loadConversations()

        this.conversationInterval = setInterval(() => {
          this.loadConversations()
        }, 1000 * 10)
      }
    }

    loadConversations() {
      const queryParams = queryString.parse(this.props.location.search);
  
      const searchParams = {
        page: queryParams.page || 1,
        status: queryParams.status || '',
        userId: queryParams.userId || '',
        patientId: queryParams.patientId || '',
      };
  
      this.props.dispatch(loadConversations(searchParams))
    }

    getConversations() {
      const queryParams = queryString.parse(this.props.location.search);
  
      const searchParams = {
        page: queryParams.page || 1,
        status: queryParams.status || '',
        userId: queryParams.userId || '',
        patientId: queryParams.patientId || '',
        locationId: queryParams.locationId || ''
      };
  
      this.props.dispatch(getConversations(searchParams))
    }

    disablePolling() {
      clearInterval(this.conversationInterval)
    }

    unSubscribeChannels() {
      if (this.conversationsChannel) {
        this.conversationsChannel.unbind();
        this.context.unsubscribe(`private-conversations_client.${this.props.clientId}`)
      }

      this.context.connection.unbind('state_change', this.connectionChange, this)
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }

  const mapStateToProps = state => {
    return {
      clientId: state.client.id,
      currentUser: state.user.currentUser,
      isLoading: state.conversation.isLoading,
      conversations: state.conversation.conversations.collection.length === 0 ? [] : state.conversation.conversations.collection,
      totalConversations: state.conversation.conversations.total,
    }
  }

  return connect(mapStateToProps)(SocketService)
}

export default withMsgListService